export default "/img/LU.5172dcf5ece8c59ade500f1da0faf481.png";